// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  padding-left: 4rem;
}
.scroll-container::-webkit-scrollbar {
  display: none;
}
.dashboard-header {
  align-items: center;
  display: flex;
}

.dashboard-divider {
  margin: 0;
}

.dashboard-invoice-download {
  color: #d2042d;
  display: flex;
  gap: 0.6rem;
  align-items: center;
  justify-content: center;
  font-family: Roboto;
}
.buyer-dashboard-content {
  margin-top: 34px;
}
.greeting-user,
.buyer-name {
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 700;
}
.greeting-user {
  color: #8e9190;
}
.buyer-name {
  color: #0a0f0d;
}
.dashboard-container .user-help-text {
  font-family: Roboto;
  font-weight: 400;
  font-size: 1rem !important;
  letter-spacing: 0%;
  color: #5b5e5d;
}
.help-icon {
  width: 32px !important;
}
.contact-us-text {
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
}
.help-center {
  font-family: Roboto;
  color: #000;
}
.highlight-text {
  font-family: Roboto;
  color: #d2042d;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.buyer-dashboard-card {
  width: "100%";
  cursor: pointer;
}
.purchases-section {
  display: flex;
  justify-content: space-between;
}
.see-all {
  font-size: 19px;
  font-weight: 500;
  margin-top: 3.375rem;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: center;
}
.arrow-icon {
  margin-left: 0.3rem;
  width: 11px;
}
.campaigns-sub-header {
  font-family: Montserrat;
  display: block;
  color: #5b5e5d;
  font-size: 19px;
  font-weight: 700;
}
.recent-purchase {
  margin-top: 3.375rem;
  margin-bottom: 0.75rem;
}
.dashboard-container .campaigns-count {
  margin-top: 2.375rem;
  margin-bottom: 1.375rem;
}
.dashboard-container .campaign-icon {
  width: 40px;
}
.dashboard-container .campaign-count {
  color: #000;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.buyer-dashboad-payments-table {
  width: 96vw;
}
.buyer-dashboad-payments-table .ant-table-row {
  cursor: pointer;
}
.dashboard-container .campaign-name {
  font-family: Roboto;
  color: #8e9190;
  font-weight: 600;
  font-size: 14px;
}
@media (max-width: 767px) {
  .dashboard-container {
    padding-left: 1.125rem;
  }
  .dashboard-header {
    height: 60px;
  }
  .buyer-dashboard-content {
    margin-top: 32px;
  }
  .dashboard-container .user-help-text {
    font-size: 13px !important;
  }
  .greeting-user,
  .buyer-name {
    font-size: 19px;
  }
  .contact-us-text {
    font-size: 13px;
    margin-top: 1.1rem;
  }
  .help-icon {
    width: 24px;
    margin-top: 31px;
  }
  .help-column {
    justify-content: end;
  }
  .campaigns-sub-header {
    margin-top: 36px;
  }
  .recent-purchase-mobile {
    color: #5b5e5d;
    font-weight: 500;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
  .mobile-campaign-cards .ant-card-body {
    padding: 1rem 0rem 1rem 1rem;
  }
  .dashboard-container .campaign-icon {
    width: 30px;
  }

  .dashboard-container .campaign-name {
    color: #8e9190;
    font-weight: 700;
    text-align: left;
    margin-top: 20px;
    font-size: 1rem;
  }
  .dashboard-container .campaign-count {
    font-size: 1.75rem;
    text-align: left;
  }

  .dashboard-container .ant-carousel .slick-dots li button {
    opacity: 1; /* to ensure visibility */
    transition: background-color 0.3s ease;
    background-color: #ccc !important;
  }

  .dashboard-container .ant-carousel .slick-dots li.slick-active,
  .dashboard-container .ant-carousel .slick-dots li {
    width: 6px;
  }

  .carousel-container {
    width: 90vw;
    margin: 0 auto;
    overflow-x: scroll;
    margin-left: -3rem;
  }
  .dashboard-container .ant-carousel .slick-list {
    overflow: visible !important;
    padding: 0;
  }
  .dashboard-container .ant-carousel .slick-dots li.slick-active button {
    background-color: #d2042d !important;
  }
  .dashboard-container .mobile-payments-card {
    margin-bottom: 20px;
  }
  .see-all {
    margin-top: 2.375rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/BuyerFlow/BuyerDashboard/BuyerDashboard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,UAAU,EAAE,yBAAyB;IACrC,sCAAsC;IACtC,iCAAiC;EACnC;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,oCAAoC;EACtC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".dashboard-container {\n  padding-left: 4rem;\n}\n.scroll-container::-webkit-scrollbar {\n  display: none;\n}\n.dashboard-header {\n  align-items: center;\n  display: flex;\n}\n\n.dashboard-divider {\n  margin: 0;\n}\n\n.dashboard-invoice-download {\n  color: #d2042d;\n  display: flex;\n  gap: 0.6rem;\n  align-items: center;\n  justify-content: center;\n  font-family: Roboto;\n}\n.buyer-dashboard-content {\n  margin-top: 34px;\n}\n.greeting-user,\n.buyer-name {\n  font-family: Montserrat;\n  font-size: 20px;\n  font-weight: 700;\n}\n.greeting-user {\n  color: #8e9190;\n}\n.buyer-name {\n  color: #0a0f0d;\n}\n.dashboard-container .user-help-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 1rem !important;\n  letter-spacing: 0%;\n  color: #5b5e5d;\n}\n.help-icon {\n  width: 32px !important;\n}\n.contact-us-text {\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n}\n.help-center {\n  font-family: Roboto;\n  color: #000;\n}\n.highlight-text {\n  font-family: Roboto;\n  color: #d2042d;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n.buyer-dashboard-card {\n  width: \"100%\";\n  cursor: pointer;\n}\n.purchases-section {\n  display: flex;\n  justify-content: space-between;\n}\n.see-all {\n  font-size: 19px;\n  font-weight: 500;\n  margin-top: 3.375rem;\n  margin-bottom: 0.5rem;\n  display: flex;\n  justify-content: center;\n}\n.arrow-icon {\n  margin-left: 0.3rem;\n  width: 11px;\n}\n.campaigns-sub-header {\n  font-family: Montserrat;\n  display: block;\n  color: #5b5e5d;\n  font-size: 19px;\n  font-weight: 700;\n}\n.recent-purchase {\n  margin-top: 3.375rem;\n  margin-bottom: 0.75rem;\n}\n.dashboard-container .campaigns-count {\n  margin-top: 2.375rem;\n  margin-bottom: 1.375rem;\n}\n.dashboard-container .campaign-icon {\n  width: 40px;\n}\n.dashboard-container .campaign-count {\n  color: #000;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.buyer-dashboad-payments-table {\n  width: 96vw;\n}\n.buyer-dashboad-payments-table .ant-table-row {\n  cursor: pointer;\n}\n.dashboard-container .campaign-name {\n  font-family: Roboto;\n  color: #8e9190;\n  font-weight: 600;\n  font-size: 14px;\n}\n@media (max-width: 767px) {\n  .dashboard-container {\n    padding-left: 1.125rem;\n  }\n  .dashboard-header {\n    height: 60px;\n  }\n  .buyer-dashboard-content {\n    margin-top: 32px;\n  }\n  .dashboard-container .user-help-text {\n    font-size: 13px !important;\n  }\n  .greeting-user,\n  .buyer-name {\n    font-size: 19px;\n  }\n  .contact-us-text {\n    font-size: 13px;\n    margin-top: 1.1rem;\n  }\n  .help-icon {\n    width: 24px;\n    margin-top: 31px;\n  }\n  .help-column {\n    justify-content: end;\n  }\n  .campaigns-sub-header {\n    margin-top: 36px;\n  }\n  .recent-purchase-mobile {\n    color: #5b5e5d;\n    font-weight: 500;\n    margin-top: 2rem;\n    margin-bottom: 1rem;\n  }\n  .mobile-campaign-cards .ant-card-body {\n    padding: 1rem 0rem 1rem 1rem;\n  }\n  .dashboard-container .campaign-icon {\n    width: 30px;\n  }\n\n  .dashboard-container .campaign-name {\n    color: #8e9190;\n    font-weight: 700;\n    text-align: left;\n    margin-top: 20px;\n    font-size: 1rem;\n  }\n  .dashboard-container .campaign-count {\n    font-size: 1.75rem;\n    text-align: left;\n  }\n\n  .dashboard-container .ant-carousel .slick-dots li button {\n    opacity: 1; /* to ensure visibility */\n    transition: background-color 0.3s ease;\n    background-color: #ccc !important;\n  }\n\n  .dashboard-container .ant-carousel .slick-dots li.slick-active,\n  .dashboard-container .ant-carousel .slick-dots li {\n    width: 6px;\n  }\n\n  .carousel-container {\n    width: 90vw;\n    margin: 0 auto;\n    overflow-x: scroll;\n    margin-left: -3rem;\n  }\n  .dashboard-container .ant-carousel .slick-list {\n    overflow: visible !important;\n    padding: 0;\n  }\n  .dashboard-container .ant-carousel .slick-dots li.slick-active button {\n    background-color: #d2042d !important;\n  }\n  .dashboard-container .mobile-payments-card {\n    margin-bottom: 20px;\n  }\n  .see-all {\n    margin-top: 2.375rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
